import type { EditorAction } from './editorState';

/** What an account without a purchase cannot do, for the actions that would
 *  do it.
 *
 *  Designing is free: every account draws the room, furnishes it and builds
 *  the whole system. What a purchase adds is treating the room — the store
 *  offers' `panel_placement` grant (`./offers`, `./entitlements`), which
 *  every room bundle and Unlimited carry. Placing furniture is part of
 *  drawing the room, not of treating it. The optimizer is not here: its
 *  results land as ordinary moves and an analysis write, indistinguishable
 *  from a manual drag, so it is gated where its job is submitted instead
 *  (and metered by compute credits). */
export type PremiumFeature = 'panels';

/** Every action that PUTS a panel into the room: the catalogue, the
 *  custom-panel designer, Ctrl+D, paste (from any tab or room), the
 *  mirror-pair button. Moving, editing or deleting what is already there
 *  stays open, so a room that arrived with panels (an example room) is
 *  still the owner's to arrange. */
const PREMIUM_ROOM_ACTIONS: Partial<Record<EditorAction['type'], PremiumFeature>> = {
  ADD_PANEL: 'panels',
};

/** The premium feature `type` needs, or null when a basic room may run it. */
export function premiumFeatureOf(type: EditorAction['type']): PremiumFeature | null {
  return PREMIUM_ROOM_ACTIONS[type] ?? null;
}
